import React from 'react'
import './card.css'

const Card = ({ picture, hover, action, children, className }) => {

  const handleClick = (event) => {
    if (action) action()
  }

  const renderPicture = () => {
    return picture ? (
      <picture>
        <img src={picture} alt=""/>
      </picture>
    ) : ''
  }

  const renderHover = () => {
    return hover ? (
      <section className="hover">{hover}</section>
    ) : ''
  }

  return (
    <div className={`card ${className}`} onClick={handleClick}>
      {renderHover()}
      {renderPicture()}
      <footer>
        {children}
      </footer>
    </div>
  )
}

export default Card



// WEBPACK FOOTER //
// ./src/lib/components/card.js